// extracted by mini-css-extract-plugin
export default {"container":"languageSwitch_container__HqKi6","container_other":"languageSwitch_container_other__dQzcA","nav":"languageSwitch_nav__PxNhg"};